import { render, staticRenderFns } from "./UserPostQuery.vue?vue&type=template&id=30875454"
import script from "./UserPostQuery.vue?vue&type=script&lang=js"
export * from "./UserPostQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports